var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "page-content special" },
    [
      _c("header-inner"),
      _c(
        "wrapper",
        { attrs: { lineBorders: false, lineCenter: true } },
        [
          _c("products-menu", {
            on: {
              currentMenu: function($event) {
                _vm.currentMenu($event)
              }
            }
          }),
          _c("section", { staticClass: "content-one desktop" }, [
            _vm.specInfo
              ? _c("div", {
                  staticClass: "text",
                  domProps: { innerHTML: _vm._s(_vm.specInfo.description) }
                })
              : _vm._e()
          ]),
          _c("no-ssr", [
            _vm.specInfo.slider.length
              ? _c(
                  "section",
                  { staticClass: "slider-section" },
                  [
                    _c(
                      "slider",
                      {
                        ref: "slider",
                        attrs: { autoplay: false, arrows: true }
                      },
                      _vm._l(_vm.specInfo.slider, function(slide, key) {
                        return _c("image-slide", {
                          key: key,
                          attrs: { size: 50, image: slide.image }
                        })
                      })
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _c(
        "wrapper",
        {
          staticClass: "mobile",
          attrs: { lineBorders: false, lineCenter: true }
        },
        [
          _c("section", { staticClass: "content-one" }, [
            _vm.specInfo
              ? _c("div", {
                  staticClass: "text",
                  domProps: { innerHTML: _vm._s(_vm.specInfo.description) }
                })
              : _vm._e()
          ])
        ]
      ),
      _c(
        "section",
        { staticClass: "content-info content-section" },
        [
          _c("wrapper", [
            _c("h2", {
              staticClass: "text-center title",
              domProps: { innerHTML: _vm._s(_vm.specTitle) }
            }),
            _c(
              "div",
              { staticClass: "row-grid content_icons" },
              _vm._l(_vm.specList, function(item, index) {
                return _vm.specList
                  ? _c("div", { key: index, staticClass: "col-md-6 item" }, [
                      _c("div", {
                        staticClass: "icons big_title upper icons_svg",
                        class: item.code,
                        domProps: { innerHTML: _vm._s(item.title) }
                      }),
                      item.preview_text
                        ? _c("div", {
                            staticClass: "description-item",
                            domProps: { innerHTML: _vm._s(item.preview_text) }
                          })
                        : _vm._e()
                    ])
                  : _vm._e()
              })
            ),
            _c("div", { staticClass: "buttons text-center" })
          ])
        ],
        1
      ),
      _vm.titleCase
        ? _c(
            "section",
            { staticClass: "block-content content-section" },
            [
              _c(
                "wrapper",
                [
                  _c("h3", {
                    staticClass: "text-center big-title",
                    domProps: { innerHTML: _vm._s(_vm.titleCase.block_title) }
                  }),
                  _c(
                    "no-ssr",
                    [
                      this.$store.state.content.entities.best2special.loaded
                        ? _c(
                            "slider",
                            {
                              ref: "slider",
                              attrs: { autoplay: false, arrows: true }
                            },
                            _vm._l(_vm.videoCase, function(slide, key) {
                              return slide.video_link
                                ? _c("video-slide", {
                                    key: key,
                                    attrs: {
                                      video: _vm.videoYoutube(slide.video_link)
                                    }
                                  })
                                : _vm._e()
                            })
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72957087", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72957087","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/products/special.vue
// module id = 93X4
// module chunks = 25